import { API_BASE_URL, API_DUMMY_RESULT } from '@/config/constants'
import * as dummy from './schedulingDummy'
import axios from 'axios'

const licenseTable = [
  { key: 'Standard', id: 1 },
  { key: 'Trial', id: 2 },
  { key: 'Free', id: 3 },
]

const roleTable = [
  { key: 'Owner', id: 1 },
  { key: 'Admin', id: 2 },
  { key: 'Member', id: 3 },
]

const statusTable = [
  { key: 'Inactive', id: 0 },
  { key: 'Active', id: 1 },
]


const getAuthHeader = (uid: string) => {
  return {
    headers: {
      'Content-Type': 'application/json',
      'Authorization': uid
    }
  }
}

export const loadDashboard = async (uid: string) => {
  const url = `${API_BASE_URL}/dashboard`
  const headers = getAuthHeader(uid)
  if (API_DUMMY_RESULT) {
    return dummy.dashboard
  }
  return axios.get(url, headers).then( async (res) => {
    // console.log('dashboard Data', res)
    return await res.data?.data.map((arr: any) => ({
      days: arr.days,
      hours: arr.hours,
      minutes: arr.minutes,
      seconds: arr.seconds,
      registerCount: arr.register_count,
      schedulingCount: arr.scheduling_count,
      target: arr?.target || '',
      start: arr?.start || '',
      end: arr?.end || '',
      createUserCount: arr?.created_user_count || 0
    }))
  })
}

export const loadRoomResource = async (uid: string) => {
  const url = `${API_BASE_URL}/management/resources`
  const headers = getAuthHeader(uid)
  return axios.get(url, headers).then( async (res) => {
    return await res.data?.resources.map((obj: any, i: number) => ({
      index: i,
      id: obj.id,
      capacity: obj.capacity,
      email: obj.email,
      language: obj.language,
      location: obj.location,
      country: obj.country,
      nameJa: obj.name_ja,
      nameEn: obj.name_en,
      createdAt: obj.created_at,
      updatedAt: obj.updated_at,
      deletedAt: obj.deleted_at
    }))
  }).catch((err) => {
    console.error(err)
    return Promise.reject(err)
  })
}

export const saveRoomSetting = async (uid: string, res: any) => {
  const url = `${API_BASE_URL}/onboarding/resources`
  const header = getAuthHeader(uid)
  const data = await getFormattedRoomData(res)
  return axios.post(url, data, header)
}

const getFormattedRoomData = async ( arr: any ) => {
  return arr.map((obj: any) => ({
    capacity: Number(obj.capacity),
    email: obj?.email || '',
    language: obj?.language || '',
    location: obj?.location || '',
    country: obj?.country || '',
    name_ja: obj?.nameJa || '',
    name_en: obj?.nameEn || '',
    created_at: obj?.createdAt || '',
    updated_at: obj?.updatedAt || '',
    deleted_at: obj?.deletedAt || ''
  }))
}

export const loadCompanyData = async (uid: string) => {
  const url = `${API_BASE_URL}/settings/company`
  const header = getAuthHeader(uid)
  return axios.get(url, header).then( async (res) => {
    const workTime = await {...res.data.work_hour_setting}
    const workHourSetting = await Object.keys(workTime).reduce((acc, cur) => {
      let result: any = {}
      result[cur] = {
        isWorkday: workTime[cur].is_workday,
        workHour: workTime[cur].work_hour,
        breakTime: workTime[cur].break_times
      }
      return { ...acc, ...result }
    }, {})
    return {
      dayPlanNg : res.data?.day_plan_ng || '',
      dayPlanOk: res.data?.day_plan_ok || '',
      timePlanNg: res.data?.time_plan_ng || '',
      timePlanOk: res.data?.time_plan_ok || '',
      sharingAdjustmentNg: res.data?.sharing_adjustment_ng || '',
      sharingAdjustmentOk: res.data?.sharing_adjustment_ok || '',
      defaultLang: res.data?.locale || '',
      workHourSetting,
      timezone: res.data.tz
    }
  }).catch((err) => {
    console.error(err)
    return Promise.reject(err)
  })
}

export const saveCompanyData = async (uid: string, data: any) => {
  const url = `${API_BASE_URL}/settings/company`
  const header = getAuthHeader(uid)
  const work_hour_setting = await Object.keys(data.workHourSetting).reduce((acc, cur) => {
    let result: any = {}
    const break_times = data.workHourSetting[cur].breakTime
    const work_hour = data.workHourSetting[cur].workHour
    result[cur] = {
      is_workday: data.workHourSetting[cur].isWorkday,
      break_times,
      work_hour,
      work_hour_list: getWorkHourList(work_hour, break_times)
    }
    return { ...acc, ...result }
  }, {})
  const resources = await getFormattedRoomData(data.rooms)
  const d = {
    domain: data.customerName,
    locale: data.defaultLang,
    day_plan_ok: data.dayPlanOk,
    day_plan_ng: data.dayPlanNg,
    time_plan_ok: data.timePlanOk,
    time_plan_ng: data.timePlanNg,
    sharing_adjustment_ok: data.sharingAdjustmentOk,
    sharing_adjustment_ng: data.sharingAdjustmentNg,
    tz: data.timezone,
    resources,
    work_hour_setting,
  }
  return axios.post(url, d, header)
}

const getWorkHourList = (workHour: any, breakTime: any) => {
  const sortedBreakTime = [].concat(breakTime).sort((a: any, b: any) => {
    return a.start.localeCompare(b.start)
  })
  let result: any = [{ start: workHour.start, end: ''}]
  let i: number = 0
  sortedBreakTime.forEach((breaktime: any) => {
    if (result[i].start.localeCompare(breaktime.start) >= 0) {
      result[i].start = breaktime.end
    } else {
      result[i].end = breaktime.start
      result.push({ start: breaktime.end, end: ''})
      i += 1
    }
  })
  const last = result.length - 1
  if (workHour.end.localeCompare(result[last].start) <= 0) {
    result.pop()
  } else {
    result[last].end = workHour.end
  }
  return result
}

export const loadUserSetting = async (uid: string) => {
  const url = `${API_BASE_URL}/settings/user`
  const headers = getAuthHeader(uid)
  if (API_DUMMY_RESULT) {
    return dummy.user
  }
  return axios.get(url, headers).then((res) => ({
    availableLocations: res.data?.user.available_locations || [],
    selectedLocation: res.data?.user.location || '',
    userLang: res.data?.user.locale || '',
    userDayPlanNg: res.data?.user.day_plan_ng || '',
    userDayPlanOk: res.data?.user.day_plan_ok || '',
    userTimePlanNg: res.data?.user.time_plan_ng || '',
    userTimePlanOk: res.data?.user.time_plan_ok || '',
    userSharingAdjustmentNg: res.data?.user.sharing_adjustment_ng || '',
    userSharingAdjustmentOk: res.data?.user.sharing_adjustment_ok || '',
  })).catch((err) => {
    console.error(err)
    return Promise.reject(err)
  })
}

export const saveUserSetting = async (uid: string, data: any) => {
  const url = `${API_BASE_URL}/settings/user`
  const header = getAuthHeader(uid)
  const d = {
    // language: data.userLang, // NOTE: コレは使ってない
    available_locations: data.availableLocations,
    location: data.selectedLocation,
    locale: data.userLang,
    day_plan_ng: data.dayPlanNg,
    day_plan_ok: data.dayPlanOk,
    time_plan_ng: data.timePlanNg,
    time_plan_ok: data.timePlanOk,
    sharing_adjustment_ng: data.sharingAdjustmentNg,
    sharing_adjustment_ok: data.sharingAdjustmentOk,
  }
  return axios.post(url, d, header)
}

export const getUserList = async (uid: string) => {
  const url = `${API_BASE_URL}/management/users`
  const header = getAuthHeader(uid)
  if (API_DUMMY_RESULT) {
    return dummy.managementUsers
  }
  return axios.get(url, header).then((res) => {
    return res.data.users.map((arr: any) => {
      const roleObj = roleTable.find((r) => r.id === arr.role)
      const licenseObj = licenseTable.find((l) => l.id === arr.license)
      const statusObj = statusTable.find((s) => s.id === arr.status)
      return {
        id: arr.user.id,
        role: roleObj?.key || '',
        license: licenseObj?.key || '',
        status: statusObj?.key || '',
        email: arr.user?.email || '',
        nameEn: arr.user?.name_en || '',
        nameJa: arr.user?.name_ja || '',
      }
    })
  })
}

export const setUserSetting = async (uid: string, data: any) => {
  const url = `${API_BASE_URL}/management/users`
  const header = getAuthHeader(uid)
  const d = await data.map((arr: any) => ({
    email: arr.email,
    name_ja: arr.nameJa,
    name_en: arr.nameEn,
    license: arr.license,
    role: arr.role,
    status: arr.status,
  }))
  return axios.post(url, d, header)
}

export const updateLicense = async (uid: string, userId: string, license: string) => {
  const url = `${API_BASE_URL}/management/users/${userId}/update-license`
  const header = getAuthHeader(uid)
  const d = licenseTable.find((obj) => obj.key === license)
  if (!d) return false
  return axios.put(url, d.id, header)
}

export const updateRole = async (uid: string, userId: string, role: string) => {
  const url = `${API_BASE_URL}/management/users/${userId}/update-role`
  const header = getAuthHeader(uid)
  const d = roleTable.find((obj) => obj.key === role)
  if (!d) return false
  return axios.put(url, d.id, header)
}

export const updateStatus = async (uid: string, userId: string, status: string) => {
  const url = `${API_BASE_URL}/management/users/${userId}/update-status`
  const header = getAuthHeader(uid)
  const d = statusTable.find((obj) => obj.key === status)
  if (!d) return false
  return axios.put(url, d.id, header)
}
